import find from 'lodash/find';

export const byId = (state, id) => find(state.services.categories.items, { id });
export const getServiceCategories = state => state.services.categories.items;
export const isFetched = state => state.services.categories.isFetched;
